import ChatPannel from './ChatPanel';
export default ChatPannel;
